import { SuggestedProductsToCustomer } from '../../../../services/modules/products/products.types';
import { UsedInOfflineMode } from '../../../offline/types/UsedInOfflineMode';
import ProductDetailsList from '../ProductDetailsList';
import { DetailsModalEntity, ProductDetailsEntityType } from '../types/productDetails.types';
import KitDetailsList from './KitDetailsList/KitDetailsList';

interface ProductDetailsEntityListProps extends UsedInOfflineMode {
  entity?: DetailsModalEntity;
  disableGrid?: boolean;
  scrollParent?: HTMLElement | null;
  suggestedProducts?: SuggestedProductsToCustomer[];
}

const ProductDetailsEntityList = ({
  entity,
  disableGrid,
  scrollParent,
  isOfflineMode = false,
  suggestedProducts,
}: ProductDetailsEntityListProps) => {
  if (entity?.type === ProductDetailsEntityType.PRODUCT) {
    return (
      <ProductDetailsList
        product={entity.data}
        disableGrid={disableGrid}
        scrollParent={scrollParent}
        isOfflineMode={isOfflineMode}
        suggestedProducts={suggestedProducts}
      />
    );
  }

  if (entity?.type === ProductDetailsEntityType.KIT) {
    return (
      <KitDetailsList
        disableGrid={disableGrid}
        scrollParent={scrollParent}
        isOfflineMode={isOfflineMode}
      />
    );
  }

  return null;
};

export default ProductDetailsEntityList;
